import { messageAssetStrings } from 'constants/strings';

type Props = {
  isRetrying?: boolean;
  onRetry: () => void;
  message?: string;
  retryLabel?: string;
  retryingLabel?: string;
};

export function MessageAssetQueryError({
  isRetrying = false,
  onRetry,
  message = messageAssetStrings.loadFailed,
  retryLabel = messageAssetStrings.retry,
  retryingLabel = messageAssetStrings.retrying,
}: Props) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
    >
      <span>{message}</span>
      <button
        type="button"
        onClick={onRetry}
        disabled={isRetrying}
        className="rounded-lg border border-red-300 bg-white px-3 py-1.5 text-xs font-semibold text-red-700 transition hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {isRetrying ? retryingLabel : retryLabel}
      </button>
    </div>
  );
}
